import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import SectionHeading from '../../components/SectionHeading';
import InstituicaoMenu from '../../components/ui/InstituicaoMenu';
import BannerSection from '../../components/ui/BannerSection';
import BreadcrumbNav from '../../components/ui/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Instituição' },
    { label: 'Apresentação' }
];

function Instituicao() {
    return (
        <>
            <header id='header'>
                <AppHeader />
            </header>
            <BannerSection
                title="Instituto Superior Politécnico Atlântida"
                subtitle="Bem-vindo ao Instituto Superior Politécnico Atlântida"
                description={`Descubra um ambiente de aprendizado inspirador e inovador, onde cada jornada educacional é guiada pela excelência.`}
                backgroundImage={require('../../assets/BannerANU_ispa.jpg')}
                backgroundId="instituition-Banner"
            />
            <BreadcrumbNav items={caminho} />
            <br />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
                <br />
                <div className="row flex-row-reverse">
                    <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                        <br />
                        <div className="details-magazine" id='detalhes'>
                            <p className="f-reg">
                                <SectionHeading title="Apresentação" />
                                O Instituto Superior Politécnico Atlântida, idealizado e fundado em 2012, legalizado pelo Decreto 
                                Presidencial Nº 168 de 24 de julho de 2012/2013, localizado no município de Belas, bairro Kifica,
                                província de Luanda, é uma instituição dotada de autonomia estatuária Pedagógica, Científica, Cultural, 
                                Administrativa, Financeira e Patrimonial. É um estabelecimento privado integrado na região académica n°1
                                do subsistema do Ensino Superior em Angola. <br /><br />
                                A actual estrutura estabelece a constituição de quatro áreas do conhecimento, a saber: Ciências da Saúde, 
                                Ciências das Engenharias e Tecnologia, Ciências da Gestão e Ciência Sociais. Ao todo, são ministrados 15 cursos de 
                                graduação: licenciatura em Direito, Relações Internacionais, Pedagogia, Psicologia, Sociologia, Gestão de Empresa,
                                Gestão de Recursos Humanos, Contabilidade, Economia, Enfermagem, Análises Clínicas, Engenharia Informática, Engenharia Civil, 
                                Farmácia e Fisioterapia.
                                <br /><br />
                            </p>
                            <br />
                        </div>
                        <br />
                    </div>
                     <div className="col-12 col-md-4 col-lg-3 col-xl-2 col-xxl-2">
                        <InstituicaoMenu />
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
            </main>
            <AppLayout />
        </>
    );
}

export default Instituicao;